/**
 * @generated SignedSource<<60ca8a6736be9a03a111794c81c2dae8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WorkspaceInviteStatus = "ACCEPTED" | "EXPIRED" | "PENDING" | "REVOKED" | "%future added value";
export type WorkspaceRole = "ADMIN" | "MEMBER" | "OWNER" | "%future added value";
export type WorkspaceMembersPageQuery$variables = {
  workspaceId: string;
};
export type WorkspaceMembersPageQuery$data = {
  readonly workspace: {
    readonly acceptedInvites: ReadonlyArray<{
      readonly acceptedAt: string | null | undefined;
      readonly email: string;
      readonly id: string;
      readonly role: WorkspaceRole;
      readonly status: WorkspaceInviteStatus;
    }>;
    readonly id: string;
    readonly members: ReadonlyArray<{
      readonly id: string;
      readonly joinedAt: string;
      readonly role: WorkspaceRole;
      readonly user: {
        readonly email: string;
        readonly id: string;
        readonly name: string;
      };
    }>;
    readonly name: string;
    readonly pendingInvites: ReadonlyArray<{
      readonly createdAt: string;
      readonly email: string;
      readonly expiresAt: string;
      readonly id: string;
      readonly role: WorkspaceRole;
      readonly status: WorkspaceInviteStatus;
    }>;
    readonly viewerMembership: {
      readonly role: WorkspaceRole;
    } | null | undefined;
  } | null | undefined;
};
export type WorkspaceMembersPageQuery = {
  response: WorkspaceMembersPageQuery$data;
  variables: WorkspaceMembersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkspaceMember",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "joinedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkspaceInvite",
  "kind": "LinkedField",
  "name": "pendingInvites",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/),
    (v4/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkspaceInvite",
  "kind": "LinkedField",
  "name": "acceptedInvites",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/),
    (v4/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "acceptedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceMembersPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceMember",
            "kind": "LinkedField",
            "name": "viewerMembership",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceMembersPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceMember",
            "kind": "LinkedField",
            "name": "viewerMembership",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "342a7d75ac5f4b7a098d1922545efed2",
    "id": null,
    "metadata": {},
    "name": "WorkspaceMembersPageQuery",
    "operationKind": "query",
    "text": "query WorkspaceMembersPageQuery(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    id\n    name\n    viewerMembership {\n      role\n      id\n    }\n    members {\n      id\n      role\n      joinedAt\n      user {\n        id\n        name\n        email\n      }\n    }\n    pendingInvites {\n      id\n      email\n      role\n      status\n      createdAt\n      expiresAt\n    }\n    acceptedInvites {\n      id\n      email\n      role\n      status\n      acceptedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fc0e0f8fe4aa9abe236a8ca6f132de1";

export default node;
